import {createSlice, Dictionary, PayloadAction} from '@reduxjs/toolkit'
import {takeEvery, getContext, call, put} from 'typed-redux-saga'
import Goal from 'src/models/Goal'
import {DataState} from 'src/types/dataState.type'
import {shouldLogUserOut} from '../configureStore'
import _ from 'lodash'
import Api from '../../api/reactpt'

export type GoalsState = {
  goals: Dictionary<Goal>
  dataState: DataState
}

const initialState: GoalsState = {
  goals: {},
  dataState: {state: 'unloaded'},
}

export const {actions, reducer} = createSlice({
  name: 'goals',
  initialState,
  reducers: {
    getGoals: (_state: GoalsState, _action: PayloadAction<void>) => {},
    setGoals: (state: GoalsState, action: PayloadAction<{goals: Goal[]}>) => {
      const keyed = _.keyBy(action.payload.goals, ({id}) => id)
      const newGoals = {...keyed} as Dictionary<Goal>
      return {...state, goals: newGoals}
    },
    setDataState: (state: GoalsState, action: PayloadAction<{dataState: DataState}>) => {
      const {dataState} = action.payload
      return {...state, dataState}
    },
    clear: (_state: GoalsState) => {
      return {...initialState}
    },
  },
})

export const getGoalsSaga = function* () {
  const api: Api = yield* getContext<Api>('api')
  yield* put(actions.setDataState({dataState: {state: 'loading'}}))
  try {
    const result = yield* call(api.getGoals)
    yield* put(actions.setGoals({goals: result}))
    yield* put(actions.setDataState({dataState: {state: 'loaded'}}))
  } catch (error) {
    if (shouldLogUserOut(error)) {
      throw error
    } else {
      yield* put(actions.setDataState({dataState: {state: 'unloaded', error}}))
    }
  }
}

export const saga = function* () {
  yield* takeEvery(actions.getGoals.type, getGoalsSaga)
}
